import CustomerLogin from "../../pages/auth/customer";
import ForgotPassword from "../../pages/auth/forgot-password";
import Login from "../../pages/auth/Login";
import ManagementLogin from "../../pages/auth/management";
import NotFound from "../../pages/auth/NotFound";
import ResetPassword from "../../pages/auth/reset-password";
import TranportAgentLogin from "../../pages/auth/transport-agent";
import TranporterLogin from "../../pages/auth/transporter";
import AboutUs from "../../pages/smp/logistics/aboutUs";
import { GoogleAuthRegisterPage } from "../../pages/smp/customer/google-register/register";
import { GoogleAuthRegisteredPage } from "../../pages/smp/customer/google-register/registered";
import CustomerHome from "../../pages/smp/customer/home";
import { RegisterCustomer } from "../../pages/registrations/customerRegistry";
import { RegisterTransportAgent } from "../../pages/registrations/transportAgentRegistry";
import { RegisterTransporter } from "../../pages/registrations/transporterRegistry";
import { RoleGuard } from "../guards";
import Faq from "../../components/customer/faq";
import MobilityHome from "../../pages/smp/logistics";
import { Subscriptions } from "../../pages/smp/subscription";
import { Subscription } from "../../pages/smp/subscription/subscription-detail";
import { Terms } from "../../pages/smp/subscription/terms";
import LoginOTP from "../../pages/auth/login-with-OTP";
import HomeOrderBookings from "../../pages/smp/order-booking/containers/bookings";
import HomeOrderDetails from "../../pages/smp/order-booking/order-details/order-details";



export const smpAppRoutes = () => {
	return ([
		{ path: "/", element: <RoleGuard roles={["Internal"]}><MobilityHome /></RoleGuard> },
		{ path: "home", element: <RoleGuard roles={["Internal"]}><CustomerHome /></RoleGuard> },
		{ path: "customer/support", element: <RoleGuard roles={["Internal"]}><Faq /></RoleGuard> },
		{ path: "register/rap", element: <RoleGuard roles={["Internal"]}><RegisterTransporter /></RoleGuard> },
		{ path: "register/customer", element: <RoleGuard roles={["Internal"]}><RegisterCustomer /></RoleGuard> },
		{ path: "register/rap-agent", element: <RoleGuard roles={["Internal"]}><RegisterTransportAgent /></RoleGuard> },
		{ path: "register", element: <RoleGuard roles={["Internal"]}><GoogleAuthRegisterPage /></RoleGuard> },
		{ path: "registered", element: <RoleGuard roles={["Internal"]}><GoogleAuthRegisteredPage /></RoleGuard> },
		{ path: "about-us", element: <RoleGuard roles={["Internal"]}><AboutUs /></RoleGuard> },
		{ path: "auth/login", element: <RoleGuard roles={["Internal"]}>< Login /></RoleGuard> },
		{ path: "auth/login-with-OTP", element: <RoleGuard roles={["Internal"]}>< LoginOTP /></RoleGuard> },
		{ path: "auth/login/rap", element: <RoleGuard roles={["Internal"]}><TranporterLogin /></RoleGuard> },
		{ path: "auth/login/rap-agent", element: <RoleGuard roles={["Internal"]}><TranportAgentLogin /></RoleGuard> },
		{ path: "auth/login/management", element: <RoleGuard roles={["Internal"]}><ManagementLogin /></RoleGuard> },
		{ path: "auth/login/customer", element: <RoleGuard roles={["Internal"]}><CustomerLogin /></RoleGuard> },
		{ path: "auth/login/forgot-password", element: <RoleGuard roles={["Internal"]}><ForgotPassword /></RoleGuard> },
		{ path: "auth/login/reset-password", element: <RoleGuard roles={["Internal"]}><ResetPassword /></RoleGuard> },
		{ path: "notfound", element: <RoleGuard roles={["Internal"]}>< NotFound /></RoleGuard> },
		{ path: "subscription", element: <RoleGuard roles={["Internal"]}><Subscriptions /></RoleGuard> },
		{ path: "subscription/:id", element: <RoleGuard roles={["Internal"]}><Subscription /></RoleGuard> },
		{ path: "terms/:id", element: <RoleGuard roles={["Internal"]}><Terms /></RoleGuard> },
		{ path: "order-booking", element: <RoleGuard roles={["Internal"]}><HomeOrderBookings /></RoleGuard> },
        { path: "order-details", element: <RoleGuard roles={["Internal"]}><HomeOrderDetails /></RoleGuard> },
	])
};
